import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface {}

interface StateInterface {}

class Default extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <div className="modal-wrap">
        <button
          className="modal__close"
          onClick={() => {
            Middleware.Ui.Modal.close();
          }}
        />
        <div className="modal modal--content">
          <div className="modal__header">
            <h1 className="modal__title">
              Правила участия в онлайн-выставке «OTM: Winter 25/26»
            </h1>
          </div>
          <div className="modal__body">
            <p>
              Онлайн-выставка «OTM: Winter 25/26» (далее — онлайн-выставка)
              проходит на портале Profi.Travel с 25 августа 2025 года по 17
              сентября 2025 года. Местом проведения онлайн-выставки является
              сайт profi.travel (далее — Официальный сайт).
            </p>
            <p>
              Онлайн-выставка «OTM: Winter 25/26» является рекламным
              стимулирующим в смысле ст. 9 Федерального закона РФ от 13.03.2006
              № 38-ФЗ «О рекламе» мероприятием, не является публичным конкурсом
              в смысле гл. 57 Гражданского кодекса РФ, соответственно, и не
              является лотереей в смысле Федерального закона РФ от 11.11.2003 №
              138-ФЗ «О лотереях».
            </p>
            <p>
              Принимая участие в онлайн-выставке, Участники полностью
              соглашаются с настоящими правилами (далее — «Правила»).
            </p>

            <hr />
            <h2>Правила розыгрыша призов и выдачи дипломов</h2>

            <h3>Основные понятия и определения</h3>

            <ol>
              <li>
                Организатором розыгрыша призов в рамках онлайн-выставки является
                ООО «Профи.Трэвел» (далее — Организатор). ИНН 6685014210, КПП
                667101001, юр. адрес: 620102, г. Екатеринбург, улица
                Шаумяна/Чкалова стр. 63/16, 512 офис. Контакты организатора:{" "}
                <a href="mailto:academy@profi.travel">academy@profi.travel</a>,{" "}
                <a href="tel:+7 (495) 120-28-25">+7 (495) 120-28-25</a>.
              </li>
              <li>
                Место выдачи призов: определение обладателей призов
                онлайн-выставки состоится 17 сентября 2025 года в прямом эфире
                на портале Profi.Travel.
              </li>
            </ol>

            <h3>Общие положения</h3>

            <ol>
              <li>
                Каждый пользователь, оплативший тариф «Базовый» и тариф Полный»
                и тариф Полный плюс», считается участником онлайн-выставки «OTM:
                Winter 25/26», организованного порталом Profi.Travel, которая
                проходит с 25 августа 2025 года по 17 сентября 2025 года.
              </li>

              <li>
                Каждый посетитель онлайн-выставки автоматически становится
                участником системы лояльности Profi.Travel Loyalty, начинает
                получать баллы за свою активность в онлайн-мероприятиях и может
                войти в рейтинг активности посетителей.
              </li>

              <li>
                Все турагенты должны соблюдать правила поведения на вебинарах.
                За нецензурные выражения, хамство и выражения, явно или косвенно
                затрагивающие честь и достоинство ведущих, модераторов и других
                участников онлайн-выставки, высказывания не по теме вебинара
                (флуд) и/или спам, мешающие общению слушателей вебинара,
                участники вебинара будут забанены. При повторении нарушения на
                этом или другом вебинаре такой пользователь будет исключен из
                списка участников онлайн-интенсива, он не сможет принять участие
                в финальном розыгрыше и тесте, а также не получит диплом.
              </li>

              <li>
                Каждый участник системы лояльности Profi.Travel Loyalty и
                онлайн-выставки «OTM: Winter 25/26» претендует на:
                <ul>
                  <li>главный призовой фонд онлайн-интенсива;</li>
                  <li>
                    главный приз по итогам программы Profi.Travel Loyalty в 2025
                    году.
                  </li>
                </ul>
              </li>

              <li>
                В рейтинге посетителей онлайн-выставки показаны первые
                1&nbsp;000 пользователей, вывод которых в списке зависит от
                количества заработанных баллов.
              </li>
            </ol>

            <h3>Правила получения баллов Loyalty</h3>

            <ol>
              <li>
                Баллы в программе Profi.Travel Loyalty автоматически начисляются
                пользователям за:
                <ul>
                  <li>регистрацию на онлайн-выставку (+10 баллов);</li>
                  <li>
                    просмотр более 50% каждого эфира онлайн-выставки (+100
                    баллов);
                  </li>
                  <li>
                    просмотр каждого эфира онлайн-выставки в архиве (+80 баллов,
                    если эфир не был просмотрен в прямом эфире);
                  </li>
                  <li>
                    просмотр стендов экспонентов онлайн-выставки (+10 баллов
                    один раз за онлайн-мероприятие);
                  </li>
                  <li>
                    скачивание каталогов экспонентов онлайн-выставки (+15 баллов
                    за каждый каталог один раз за онлайн-мероприятие);
                  </li>
                  <li>
                    прохождение финального тестирования на итоговом эфире (+100
                    баллов за каждый правильный ответ, максимум за 10 вопросов
                    тестирования — +1 000 баллов).
                  </li>
                </ul>
              </li>

              <li>
                Количество баллов за действия пользователя обозначены:
                <ul>
                  <li>на веб-странице онлайн-мероприятия;</li>
                  <li>
                    в личном кабинете пользователя, разделе «Баллы и рейтинг»;
                  </li>
                  <li>
                    на сайте программы Profi.Travel Loyalty{" "}
                    <a href="https://profi.travel/loyalty" target="_blank">
                      https://profi.travel/loyalty
                    </a>
                    ;
                  </li>
                  <li>
                    в личном кабинете на сайте Profi.Travel{" "}
                    <a href="https://profi.travel/" target="_blank">
                      https://profi.travel/
                    </a>
                    .
                  </li>
                </ul>
              </li>
            </ol>

            <h3>Призовой фонд и диплом</h3>

            <ol>
              <li>
                Каждый участник онлайн-выставки, претендующий на призы, должен
                иметь полностью заполненный профайл на портале Profi.Travel. В
                случае, если профайл победителя не полностью заполнен и имеет
                пустые графы, то результаты розыгрыша будут пересмотрены в
                пользу другого участника. Профайл также обязательно должен
                содержать фотографию пользователя. Тем, у кого не будет заполнен
                профайл, диплом участника выставки выдаваться не будет.
              </li>

              <li>
                ВАЖНО: диплом участника выставки получают только те участники,
                которые посмотрели в прямом эфире минимум 10 онлайн-эфиров (не
                учитывая эфиры деловой программы, перечисленные в разделе
                «Правила получения баллов Loyalty»). Диплом будет выписан на те
                имя и фамилию пользователя, которые указаны в профайле,
                изменение данных в дипломе после его выписки невозможно.
                Обратите внимание и проверьте, верно ли в вашем профайле
                написаны имя, фамилия, должность, компания. Отчество указывать
                не требуется.
              </li>

              <li>Призовой фонд выставки «OTM: Winter 25/26» уточняется</li>

              {/* <li>
                Призовой фонд выставки «OTM: Winter 25/26»:
                <ul>
                  <li>
                    6 ночей в Дубае для двоих в отелях Rotana Hotels &amp;
                    Resorts
                  </li>
                  <li>Тур в Беларусь на 2 дня от туроператора «Виаполь»</li>
                  <li>5 ночей в Riolavitas Resort &amp; Spa в Анталье</li>
                </ul>
              </li> */}

              <li>
                Определение обладателей призов онлайн-выставки состоится 17
                сентября 2025 года в прямом эфире на портале Profi.Travel.
              </li>

              <li>
                Претендентами на призовой фонд выставки «OTM: Winter 25/26»
                становятся пользователи:
                <ul>
                  <li>
                    зарегистрировавшиеся на соответствующее онлайн-мероприятие;
                  </li>
                  {/* <li>заполнившие все поля в профиле участника;</li>
                  <li>прошедшие финальное тестирование;</li> */}
                  <li>
                    вошедшие в лидеры рейтинга Loyalty, набравшие максимальное
                    количество баллов, а также те, кто отстают от лидеров
                    максимум на 800 баллов.
                  </li>
                  <li>ставшие победителями в розыгрыше среди лидеров.</li>
                </ul>
              </li>

              <li>
                Розыгрыш призового фонда проводится организатором
                онлайн-выставки (academy@profi.travel, +7 (495) 120-28-25) и
                может быть представлен Пользователям в любом удобном формате
                (публикация итогов в новости, видеозапись, прямой эфир).
              </li>

              <li>
                К участию в розыгрыше призов допускаются только сотрудники
                турагентств. По запросу организаторов мероприятия каждый
                турагент — участник акций должен будет подтвердить свой
                профессиональный статус при помощи визитки или письма от
                работодателя. В том случае, если статус участника не
                подтверждается, организаторы могут пересмотреть результаты
                лотереи, тестирования и других акций.
              </li>

              <li>
                Сотрудники компаний-туроператоров, а также самостоятельные
                турагенты, работающие с системами онлайн-бронирования (например,
                Workle), не могут претендовать на призовой фонд онлайн-выставки
              </li>

              <li>
                Полные условия использования приза, а также сроки, место и
                порядок его получения будут предоставлены победителю при
                выигрыше конкретного приза. В том случае, если победитель не
                сможет соблюсти указанные партнером условия на получение
                подарка, он не сможет его реализовать.
              </li>

              <li>
                Организатор оставляет за собой право изменить сроки проведения
                онлайн-выставки, продлить или досрочно завершить
                онлайн-выставку, объявив об этом на официальном сайте. Все
                решения Организатора являются окончательными и обжалованию не
                подлежат.
              </li>

              <li>
                Персональные данные, добровольно предоставляемые Участником на
                официальном сайте онлайн-выставки и в профиле Пользователя,
                используются Организатором и/или его уполномоченными лицами в
                целях проведения онлайн-выставки.
              </li>
              <li>
                Имена, фамилии, фото- и видеоматериалы с изображением
                участников, связанные с участием в онлайн-выставке, а также
                интервью и иные материалы о них могут быть использованы
                Организатором для выполнения обязательств по проведению
                онлайн-выставки или в иных целях, не противоречащих
                законодательству РФ.
              </li>
              <li>
                Данное Положение является единственным официальным документом
                участия в онлайн-выставке. В случае возникновения ситуаций,
                допускающих неоднозначное толкование данного Положения и/или
                вопросов, не урегулированных им, окончательное решение о таком
                толковании принимается непосредственно и исключительно
                Организатором онлайн-выставки.
              </li>
              <li>
                Во всем, что не предусмотрено настоящими Правилами и
                Положениями, Организатор и Участники онлайн-выставки
                руководствуются действующим законодательством Российской
                Федерации.
              </li>
              <li>
                Участие в онлайн-выставке автоматически подразумевает
                самостоятельное ознакомление и полное согласие Участников
                онлайн-выставки с настоящими Правилами.
              </li>
            </ol>

            <h3>Защита персональных данных </h3>
            <ol>
              <li>
                Факт регистрации на официальном сайте онлайн-выставки является
                согласием Участника на обработку персональных данных (номер
                мобильного телефона, фамилия, имя и отчество, почта, место
                работы, город) самим Организатором или привлеченными им лицами в
                строгом соответствии с целями, установленными настоящими
                Правилами.
              </li>

              <li>
                Цель обработки персональных данных — проведение онлайн-выставки
                в соответствии с настоящими Правилами и действующим
                законодательством Российской Федерации.
              </li>

              <li>
                Перечень персональных данных, которые предоставляются Участником
                и обрабатываются Организатором или привлекаемыми им лицами,
                установлен и ограничивается настоящими Правилами: сбор, запись,
                систематизация, накопление, хранение, уточнение (обновление,
                изменение), извлечение, использование, передача
                (распространение, предоставление, доступ), обезличивание,
                блокирование, удаление, уничтожение персональных данных.
              </li>

              <li>
                Трансграничная передача персональных данных в рамках проведения
                онлайн-выставки не осуществляется.
              </li>

              <li>
                Организатор и привлеченные им лица осуществляют обработку
                персональных данных Участников в строгом соответствии с
                принципами и правилами, установленными Федеральным законом
                Российской Федерации от 27.07.2006 № 152-ФЗ «О персональных
                данных», включая соблюдение конфиденциальности и обеспечение
                безопасности персональных данных при их обработке, включая
                требования к защите, установленные ст. 19 названного Закона.
              </li>

              <li>
                Организатор организует обработку персональных данных в срок
                проведения онлайн-выставки.
              </li>

              <li>
                Участник вправе в любое время отозвать разрешение на обработку
                персональных данных путем направления письма на электронную
                почту academy@profi.travel либо письменного заявления Почтой
                России ценным письмом с описью вложения по почтовому адресу
                Организатора, что влечет автоматическое прекращение участия в
                онлайн-выставке лица, отозвавшего свои персональные данные.
              </li>
            </ol>

            <h3>Рассылки и уведомления</h3>
            <p>
              Регистрируясь на онлайн-выставку, пользователь подтверждает свое
              согласие на получение информационных и маркетинговых рассылок от
              организатора, включая напоминания о предстоящих вебинарах, новости
              онлайн-выставки и иные уведомления, связанные с участием в
              мероприятии.
            </p>
            <p>
              Пользователь в любое время может отказаться от получения рассылок
              одним из следующих способов:
            </p>

            <ol>
              <li>
                в личном кабинете на сайте{" "}
                <a target="_blank" href="https://profi.travel">
                  https://profi.travel
                </a>{" "}
                в разделе «Настройки сайта»;
              </li>
              <li>по ссылке «Отписаться» внизу любого электронного письма;</li>
              <li>
                написав письмо на электронную почту:{" "}
                <a href="mailto:academy@profi.travel">academy@profi.travel</a>.
              </li>
            </ol>

            <hr />
            <h2>
              Правила участия в видеоконференциях, предоставления доступа к
              нетворкингу
            </h2>
            <p>
              Настоящие правила участия в видеоконференциях, предоставления
              доступа к нетворкингу (далее — «Правила»), проводимых с помощью
              сети Интернет в рамках онлайн-выставки, представляют собой
              публичную оферту в соответствии со статьей 435 и пунктом 2 статьи
              437 Гражданского кодекса РФ, заключенную между ООО «Профи.Трэвел»
              (далее — «Администратор») с одной стороны и Пользователем с другой
              стороны.
            </p>
            <p>
              Согласием Пользователя с настоящими Правилами (акцептом оферты)
              считается факт регистрации Пользователя на Сервисе.
            </p>

            <h3>Основные понятия и определения</h3>
            <p>
              Настоящие условия (далее — «Условия») определяют порядок участия в
              видеоконференциях, предоставления доступа к нетворкингу в рамках
              онлайн-выставки.
            </p>
            <p>
              Администратором является ООО «Профи.Трэвeл», ИНН 6685014210, КПП
              667101001, юр. адрес: 620102, г. Екатеринбург, улица
              Шаумяна/Чкалова стр. 63/16, 512 офис. Контакты организатора:
              academy@profi.travel, +7 (495) 120-28-25.
              <br />
              Тел.<a href="tel:+7 (495) 120-28-25"> +7 (495) 120-28-25.</a>
              <br />
              E-mail:{" "}
              <a href="mailto:academy@profi.travel">academy@profi.travel.</a>
            </p>
            <p>
              <b>Сервис</b> — разработанная Администратором совокупность
              интегрированных программно-аппаратных и технических средств, а
              также информации, предназначенной для общения и установления
              деловых контактов, в том числе посредством видеосвязи, в
              текстовой, графической или звуковых формах.
            </p>
            <p>
              <b>Администратор</b> — уполномоченные лица, устанавливающие
              порядок использования Сервиса, управляющие работой Сервиса и
              контролирующие выполнение Пользователями настоящих Правил.
            </p>
            <p>
              <b>Акцепт</b> — принятие всех без исключения условий настоящих
              Правил посредством осуществления процедуры Регистрации на Сервисе,
              после чего настоящие Правила приобретают юридический статус
              письменной сделки.
            </p>
            <p>
              <b>Пользователь</b> — дееспособное совершеннолетнее физическое
              лицо, добровольно прошедшее регистрацию на Сервисе, являющееся
              одной из сторон настоящих Правил.
            </p>
            <p>
              <b>Участник видеоконференции</b> — Пользователь, непосредственно
              принимающий участие в видеоконференции, проводимой с помощью
              Сервиса, являющийся одной из сторон настоящих Правил.
            </p>
            <p>
              <b>Регистрация</b> — процедура, в ходе которой Пользователь
              предоставляет достоверные данные о себе по утвержденной
              Администрацией форме, а также Пароль.
            </p>
            <p>
              <b>Персональные данные</b> — информация, предоставленная
              Пользователем во время процедуры Регистрации на Сервисе, которая
              указывает лично на Пользователя; другие сведения, которые могут
              быть обоснованно отнесены к такой информации, в том числе, но не
              исключая: фамилия, имя, отчество, адрес электронной почты,
              должность и наименование организации, в которой работает
              Пользователь, а также иная информация, указанная Пользователем при
              Регистрации на Сервисе. Указание таких данных является необходимым
              условием акцепта Оферты. Данные хранятся в базе данных
              Администратора и подлежат использованию исключительно в
              соответствии с настоящими Правилами и действующим
              законодательством РФ.
            </p>
            <p>
              <b>Учетная запись</b> — совокупность данных о Пользователе,
              включающая информацию, предоставляемую Пользователем, и внутреннюю
              информацию Сервиса о Пользователе.
            </p>
            <p>
              <b>Онлайн-чат</b> — средство обмена в реальном времени сообщениями
              между Участниками видеоконференции в Сервисе.
            </p>
            <p>
              <b>Спам</b> — телематическое электронное сообщение,
              предназначенное неопределенному кругу лиц, доставленное абоненту и
              (или) пользователю без их предварительного согласия и не
              позволяющее определить отправителя этого сообщения, в том числе
              ввиду указания в нем несуществующего или фальсифицированного
              адреса отправителя.
            </p>

            <h3>Общие положения</h3>
            <ol>
              <li>
                Пользователь обязуется ознакомиться с Правилами и сопутствующими
                им документами, размещенными в свободном доступе на Сервисе, до
                его акцепта.
              </li>
            </ol>

            <h3>
              Порядок и условия участия в видеоконференциях, предоставления
              доступа к нетворкингу
            </h3>

            <ol>
              <li>
                Участник видеоконференции уведомлен и согласен, что он должен
                соблюдать на площадке проведения видеоконференции и/или
                использования онлайн-чата правила делового общения, не находится
                в состоянии алкогольного или наркотического опьянения.
                <br />В случае нарушения требований настоящего пункта
                Администратор оставляет за собой право исключить Участника
                видеоконференции и/или его сообщение в онлайн-чате с площадки
                проведения видеоконференции
              </li>
              <li>
                Участник видеоконференции несет полную ответственность за любые
                действия, совершенные им на площадке проведения видеоконференции
                и/или использования онлайн-чата, а также за любые последствия,
                которые повлекли эти действия.
              </li>
              <li>
                В случае использования доступа к нетворкингу и/или участия в
                видеоконференциях, а также использования онлайн-чата
                Пользователи и/или Участники видеоконференции вправе задавать
                вопросы и участвовать в дискуссии. Администратор не гарантирует
                получение ответов на вопросы, направленные посредством
                нетворкинга, видеоконференции и/или онлайн-чата.
              </li>
              <li>
                Пользователю при использовании доступа к нетворкингу и Участнику
                видеоконференции на площадке проведения видеоконференции
                запрещается загружать, публиковать, распространять, агитировать,
                пропагандировать и иным образом использовать любую информацию,
                которая:
                <ul>
                  <li>
                    содержит угрозы, дискредитирует, оскорбляет, порочит честь и
                    достоинство или деловую репутацию или нарушает
                    неприкосновенность частной жизни других Пользователей,
                    Участников видеоконференции или третьих лиц;
                  </li>
                  <li>нарушает права несовершеннолетних лиц;</li>
                  <li>
                    является вульгарной или непристойной, содержит нецензурную
                    лексику, содержит порнографические изображения и тексты или
                    сцены сексуального характера;
                  </li>
                  <li>
                    содержит сцены насилия либо бесчеловечного обращения с
                    животными;
                  </li>
                  <li>
                    содержит описание средств и способов суицида, любое
                    подстрекательство к его совершению;
                  </li>
                  <li>
                    пропагандирует и/или способствует разжиганию расовой,
                    религиозной, этнической ненависти или вражды, пропагандирует
                    фашизм или идеологию расового превосходства;
                  </li>

                  <li>содержит экстремистские материалы;</li>
                  <li>
                    пропагандирует преступную деятельность или содержит советы,
                    инструкции или руководства по совершению преступных
                    действий;
                  </li>
                  <li>
                    содержит информацию ограниченного доступа, включая
                    государственную и коммерческую тайну, информацию о частной
                    жизни третьих лиц, но не ограничиваясь этим;
                  </li>
                  <li>носит мошеннический характер;</li>
                  <li>
                    является интеллектуальной собственностью третьих лиц, не
                    дававших разрешение Пользователю и/или Участнику
                    видеоконференции на ее использование,
                  </li>
                  <li>
                    а также нарушает иные права и интересы граждан и юридических
                    лиц или требования законодательства Российской Федерации и
                    законодательства других стран.
                  </li>
                </ul>
              </li>
              <li>
                За действия в связи с участием в видеоконференциях и/или
                предоставлением доступа к нетворкингу Пользователь несет
                ответственность в соответствии с действующим законодательством
                Российской Федерации.
              </li>
            </ol>

            <h3>Права и обязанности Администратора</h3>
            <b>Администратор вправе:</b>
            <ol>
              <li>
                направить Пользователю уведомление об устранении нарушения в
                случае получения информации от третьих лиц о нарушении их прав;
              </li>
              <li>
                проводить профилактические работы, влекущие приостановление
                работы Сервиса, без уведомления Пользователя;
              </li>
              <li>
                удалять комментарии без согласия Пользователя и блокировать
                оставившего комментарий Пользователя в случае выявления
                нарушений, указанных в пункте 3.4 настоящих Правил;
              </li>
              <li>
                отказать в регистрации Пользователю, учетная запись которого
                была ранее удалена за нарушение условий настоящих Правил.
              </li>
            </ol>

            <b>Администратор обязан:</b>
            <ol>
              <li>
                соблюдать положения, условия настоящих Правил и действующего
                законодательства Российской Федерации;
              </li>
              <li>
                принимать меры, направленные на пресечение правонарушений, а
                также нарушений положений, условий настоящих Правил при условии
                не анонимного, достоверного, подтвержденного доказательствами
                сообщения заинтересованных и обязанных лиц — правоохранительных
                и иных государственных органов, организаций, иных пользователей.
              </li>
            </ol>

            <h3>Права и обязанности Пользователя</h3>

            <b>Пользователь вправе:</b>
            <ol>
              <li>
                пользоваться Сервисом в пределах, предоставленных
                Администрацией, с соблюдением положений, условий настоящих
                Правил, не нарушая действующее законодательство Российской
                Федерации;
              </li>
              <li>потребовать удалить свои персональные данные;</li>
              <li>
                сообщать Администрации о нарушении положений, условий и
                настоящих Правил и норм действующего законодательства Российской
                Федерации, а также законодательства других стран в отношении
                других Пользователей Сервиса.
              </li>
            </ol>

            <b>Пользователь обязан:</b>
            <ol>
              <li>
                при использовании Сервиса соблюдать законодательство Российской
                Федерации, условия настоящих Правил и иных внутренних
                специальных документов Администрации;
              </li>
              <li>
                информировать Администрацию о несанкционированном доступе к
                персональной странице и/или о несанкционированном доступе и/или
                использовании пароля и логина Пользователя;
              </li>
              <li>
                в случае изменения данных самостоятельно внести изменения в свой
                профиль на Сервисе, в противном случае Администратор не несет
                ответственности за ущерб, причиненный Пользователю в связи с
                использованием на Сервисе недействительных данных;
              </li>
              <li>
                обеспечить достоверность предоставляемой при регистрации на
                Сервисе информации;
              </li>
              <li>
                не пытаться любым способом путем подбора пароля, взлома либо
                других действий получать доступ к чужим логинам и паролям.
                Действовать только под своим логином с использованием своего
                пароля и аккаунта;
              </li>
              <li>
                не использовать ссылки на страницы Сервиса или на сам Сервис в
                спам-рассылках (массовая рассылка рекламы без согласия на то
                получателя);
              </li>
              <li>
                соблюдать иные обязанности, предусмотренные настоящими
                Правилами, а также обусловленные нормами действующего
                законодательства Российской Федерации, обычаями делового
                оборота, требованиями разумности, добропорядочности и
                справедливости, нормами этики и морали;
              </li>
              <li>
                самостоятельно обеспечить себе качественную передачу информации,
                стабильное бесперебойное интернет-соединение, гарнитуру, звук,
                веб-камеру и прочее техническое оборудование, необходимое для
                участия в видеоконференциях и/или доступа к нетворкингу;
              </li>
              <li>
                при использовании любого контента, полученного в рамках участия
                в видеоконференциях и являющегося интеллектуальной
                собственностью, самостоятельно согласовывать такое использование
                с его правообладателями.
              </li>
            </ol>
            <b>Пользователям запрещается:</b>
            <ol>
              <li>
                нарушать какие-либо интеллектуальные права Администратора;
              </li>
              <li>создавать аккаунты с помощью автоматизированных средств;</li>
              <li>
                осуществлять сбор персональных данных других Пользователей с
                целью их последующей обработки;
              </li>
              <li>
                регистрировать пользовательский аккаунт от имени лица, которым
                Вы не являетесь (фальшивый аккаунт), и любым способом, в том
                числе путем взлома, пытаться получить доступ к чужому аккаунту;
              </li>
              <li>
                использовать любые автоматические или автоматизированные
                средства для сбора информации, размещенной на Сервисе;
              </li>
              <li>
                размещать недостоверную информацию, порочащую честь, достоинство
                или деловую репутацию третьего лица.
              </li>
            </ol>

            <h3>Ответственность и ограничение ответственности</h3>
            <ol>
              <li>
                Администратор не несет ответственности в случае указания
                Пользователем неполных и/или некорректных данных в
                регистрационной форме и/или пропуска даты видеоконференции.
              </li>
              <li>
                Пользователь понимает и соглашается, что Администратор не несет
                перед ним ответственность за любое размещенное не
                Администратором содержание, включая тексты и комментарии,
                изображения, а также любую другую информацию, размещенную
                третьими лицами, но не ограничиваясь этим.
              </li>
              <li>
                Администратор не отвечает за любые технические сбои или иные
                проблемы любых телефонных сетей или служб, компьютерных систем,
                серверов или провайдеров, компьютерного или телефонного
                оборудования, программного обеспечения, сбои сервисов
                электронной почты или скриптов по техническим причинам.
              </li>
              <li>
                Администратор не отвечает за соответствие содержимого Сервиса
                целиком или его частей (служб) ожиданиям Пользователей,
                безошибочную и бесперебойную работу Сервиса, прекращение доступа
                Пользователя к Сервису, не связанного с действиями
                Администратора, сохранность логина и пароля Пользователя,
                обеспечивающих доступ к Сервису, убытки, возникшие у
                Пользователей по причинам, связанным с техническими сбоями
                аппаратного или программного обеспечения.
              </li>
              <li>
                Пользователь полностью ответственен за сохранность ссылки и кода
                доступа, предоставленных Администратором, и за убытки, которые
                могут возникнуть по причине их утраты или несанкционированного
                их использования.
              </li>
              <li>
                Администратор не несет ответственности за любой ущерб
                электронным устройствам Пользователя или иного лица, мобильным
                устройствам, любому другому оборудованию или программному
                обеспечению, вызванный предоставлением доступа или связанный с
                ним.
              </li>
              <li>
                Ни при каких обстоятельствах Администратор не несет
                ответственность перед Пользователем или любыми третьими лицами
                за любой прямой, косвенный, неумышленный ущерб, включая
                упущенную выгоду или потерянные данные, вред чести, достоинству
                или деловой репутации, вызванные в связи с использованием
                Сервиса.
              </li>
              <li>
                Администратор не несет ответственности перед Пользователем или
                любыми третьими лицами за:
                <ul>
                  <li>действия Пользователя на Сервисе;</li>
                  <li>
                    за содержание и законность, достоверность информации,
                    используемой/получаемой Пользователем в связи с присутствием
                    на видеоконференции;
                  </li>
                  <li>
                    за последствия применения информации,
                    используемой/получаемой Пользователем в связи с присутствием
                    на видеоконференции.
                  </li>
                </ul>
              </li>
              <li>
                Администратор не несет ответственности, если подтверждение
                регистрации, код доступа и ссылка на видеоконференцию не будут
                получены Пользователем из-за технических сбоев или настроек
                спам-фильтров в почтовом сервисе Пользователя.
              </li>
            </ol>

            <b>Защита персональных данных</b>
            <ol>
              <li>
                Факт регистрации на Сервис Администратора является согласием
                Пользователя на обработку персональных данных (номер мобильного
                телефона, фамилия, имя и отчество, почта, место работы, город)
                самим Администратором или привлеченными им лицами в строгом
                соответствии с целями, установленными настоящими Правилами.
              </li>
              <li>
                Цель обработки персональных данных — участие в
                видеоконференциях, предоставление доступа к нетворкингу в
                соответствии с настоящими Правилами и действующим
                законодательством РФ.
              </li>
              <li>
                Перечень персональных данных, которые предоставляются
                Пользователями и обрабатываются Администрацией или привлекаемыми
                им лицами, установлен и ограничивается настоящими Правилами.
              </li>
              <li>
                Перечень действий с предоставляемыми Пользователями
                персональными данными: сбор, запись, систематизация, накопление,
                хранение, уточнение (обновление, изменение), извлечение,
                использование, передача (распространение, предоставление,
                доступ), обезличивание, блокирование, удаление, уничтожение
                персональных данных.
              </li>
              <li>
                Администратор и привлеченные им лица осуществляют обработку
                персональных данных Пользователей в строгом соответствии с
                принципами и правилами, установленными Федеральным законом от
                27.07.2006 № 152-ФЗ «О персональных данных», включая соблюдение
                конфиденциальности и обеспечение безопасности персональных
                данных при их обработке, включая требования к защите,
                установленные ст. 19 названного Закона.
              </li>
              <li>
                Пользователь вправе в любое время отозвать разрешение на
                обработку персональных данных путем направления письма на
                электронную почту{" "}
                <a href="mailto:academy@profi.travel">academy@profi.travel</a>{" "}
                либо письменного заявления посредством почтовой службы по
                почтовому адресу Администратора, что влечет автоматическое
                прекращение существования учетной записи Пользователя,
                отозвавшего свои персональные данные.
              </li>
            </ol>

            <b>Заключительные положения</b>
            <ol>
              <li>
                В любые положения настоящих Правил могут быть внесены изменения
                посредством опубликования Правил в новой редакции на Сервисе
                Администратора, при этом Пользователь обязан самостоятельно
                отслеживать такие изменения на Сервис и несет риск негативных
                последствий, вызванный несоблюдением данной обязанности. В
                случае внесения изменений в настоящие Правила такие изменения
                вступают в силу с момента их размещения, если иной срок
                вступления изменений в силу не определен при таком размещении.
              </li>
              <li>
                Настоящие Правила и отношения между Администратором и
                Пользователем регулируются и толкуются в соответствии с
                законодательством Российской Федерации. Вопросы, н
                урегулированные Правилами, подлежат разрешению в соответствии с
                законодательством Российской Федерации.
              </li>
              <li>
                Данные Правила являются единственным официальным документом
                участия в видеоконференциях, предоставления доступа к
                нетворкингу. В случае возникновения ситуаций, допускающих
                неоднозначное толкование данных Правил и/или вопросов, не
                урегулированных им, окончательное решение о таком толковании
                принимается непосредственно и исключительно Администратором.
              </li>
              <li>
                По всем вопросам, касающимся участия в видеоконференциях,
                предоставления доступа к нетворкингу, Пользователь должен
                обращаться исключительно по электронному адресу Администратора:{" "}
                <a href="mailto:academy@profi.travel">academy@profi.travel</a>.
              </li>
            </ol>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
